export class s {
  static createFreeAccount = "createFreeAccount";
  static matchWithPlayers = "matchWithPlayers";
  static continueWithGoogle = "continueWithGoogle";
  static emailAddress = "emailAddress";
  static continue = "continue";
  static alreadyHaveAccount = "alreadyHaveAccount";
  static logIn = "logIn";
  static createPasswordFor = "createPasswordFor";
  static password = "password";
  static atLeast8Chars = "atLeast8Chars";
  static atLeast1Uppercase = "atLeast1Uppercase";
  static atLeast1Lowercase = "atLeast1Lowercase";
  static atLeast1Number = "atLeast1Number";
  static createAccount = "createAccount";
  static agreeToTerms = "agreeToTerms";
  static termsOfServiceStr = "termsOfServiceStr";
  static and = "and";
  static privacyPolicyStr = "privacyPolicyStr";
  static or = "or";
  static emailNotValid = "emailNotValid";
  static noAccount = "noAccount";
  static registration = "registration";
  static forgotPassword = "forgotPassword";
  static fillPasswordFor = "fillPasswordFor";
  static wrongPassword = "wrongPassword";
  static forgotPasswordPrompt = "forgotPasswordPrompt";
  static enterPadelEmail = "enterPadelEmail";
  static sendResetLink = "sendResetLink";
  static rememberPassword = "rememberPassword";
  static backToLogin = "backToLogin";
  static requestSent = "requestSent";
  static emailSentTo = "emailSentTo";
  static checkInbox = "checkInbox";
  static didNotReceiveEmail = "didNotReceiveEmail";
  static sendAgain = "sendAgain";
  static firstThingsFirst = "firstThingsFirst";
  static addProfilePicture = "addProfilePicture";
  static addUsername = "addUsername";
  static hello = "hello";
  static answerQuestions = "answerQuestions";
  static sure = "sure";
  static skip = "skip";
  static skipForNow = "skipForNow";
  static racketSportsExperience = "racketSportsExperience";
  static yes = "yes";
  static no = "no";
  static haveNprpRating = "haveNprpRating";
  static rateSkillLevel = "rateSkillLevel";
  static beginner = "beginner";
  static intermediate = "intermediate";
  static advanced = "advanced";
  static cityPlayIn = "cityPlayIn";
  static location = "location";
  static search = "search";
  static gender = "gender";
  static genderPreferenceInfo = "genderPreferenceInfo";
  static male = "male";
  static female = "female";
  static nonBinary = "nonBinary";
  static showInProfile = "showInProfile";
  static dateOfBirth = "dateOfBirth";
  static memberOfPadelClub = "memberOfPadelClub";
  static usedToBeMember = "usedToBeMember";
  static howLongPlaying = "howLongPlaying";
  static lessThan1Year = "lessThan1Year";
  static oneToFiveYears = "oneToFiveYears";
  static moreThanFiveYears = "moreThanFiveYears";
  static howOftenPlayPadel = "howOftenPlayPadel";
  static almostDaily = "almostDaily";
  static threeToFourTimesAWeek = "threeToFourTimesAWeek";
  static oneToTwoTimesAWeek = "oneToTwoTimesAWeek";
  static weekly = "weekly";
  static aFewTimesAMonth = "aFewTimesAMonth";
  static rarely = "rarely";
  static anythingToAdd = "anythingToAdd";
  static describeYourself = "describeYourself";
  static describeYourselfExample = "describeYourselfExample";
  static text = "text";
  static addIndustry = "addIndustry";
  static commonTopicsInfo = "commonTopicsInfo";
  static technology = "technology";
  static healthcare = "healthcare";
  static education = "education";
  static marketing = "marketing";
  static finance = "finance";
  static energy = "energy";
  static hospitality = "hospitality";
  static insurance = "insurance";
  static arts = "arts";
  static logistics = "logistics";
  static retail = "retail";
  static engineering = "engineering";
  static research = "research";
  static sports = "sports";
  static law = "law";
  static media = "media";
  static realEstate = "realEstate";
  static fashion = "fashion";
  static nonprofit = "nonprofit";
  static addSocialLinks = "addSocialLinks";
  static instagram = "instagram";
  static linkedin = "linkedin";
  static customizingExperience = "customizingExperience";
  static creatingProfile = "creatingProfile";
  static chooseNprpRating = "chooseNprpRating";
  static beginnerRange = "beginnerRange";
  static intermediateRange = "intermediateRange";
  static advancedRange = "advancedRange";
  static true = "true";
  static false = "false";
  static backToWebsite = "backToWebsite";
  static howAppWorks = "howAppWorks";
  static aboutUs = "aboutUs";
  static benefits = "benefits";
  static joinWaitlist = "joinWaitlist";
  static findNextPadelPartners = "findNextPadelPartners";
  static getStarted = "getStarted";
  static problem = "problem";
  static solution = "solution";
  static smartMatchmaking = "smartMatchmaking";
  static smartMatchmakingDesc = "smartMatchmakingDesc";
  static instantChat = "instantChat";
  static instantChatDesc = "instantChatDesc";
  static gameNotification = "gameNotification";
  static gameNotificationDesc = "gameNotificationDesc";
  static courtRatingOption = "courtRatingOption";
  static courtRatingOptionDesc = "courtRatingOptionDesc";
  static connectWithPlayers = "connectWithPlayers";
  static getMatchNotifications = "getMatchNotifications";
  static discoverCourts = "discoverCourts";
  static whosAlreadyJoined = "whosAlreadyJoined";
  static janKowalski = "janKowalski";
  static aceBailey = "aceBailey";
  static professionalSportsman = "professionalSportsman";
  static miamiUSA = "miamiUSA";
  static emilyJohnson = "emilyJohnson";
  static studentTrainee = "studentTrainee";
  static bostonUSA = "bostonUSA";
  static eddyChad = "eddyChad";
  static itDeveloper = "itDeveloper";
  static nycUSA = "nycUSA";
  static findPeople = "findPeople";
  static abigailMitchell = "abigailMitchell";
  static oliviaBennett = "oliviaBennett";
  static danielHarrison = "danielHarrison";
  static viewProfiles = "viewProfiles";
  static filterPlayers = "filterPlayers";
  static selectAndChat = "selectAndChat";
  static createOpenInvites = "createOpenInvites";
  static enterEmailJoinWaitlist = "enterEmailJoinWaitlist";
  static addYourEmail = "addYourEmail";
  static joinTheWaitlist = "joinTheWaitlist";
  static contactUs = "contactUs";
  static contactEmail = "contactEmail";
  static instagramHandle = "instagramHandle";
  static reportIssue = "reportIssue";
  static helpCenter = "helpCenter";
  static findingPadelPartnersDescription = "findingPadelPartnersDescription";
  static padelMatchDescription = "padelMatchDescription";
  static yourRequestHasBeenSent = "yourRequestHasBeenSent";
  static changePassword = "changePassword";
  static enterNewPasswordForLogin = "enterNewPasswordForLogin";
  static repeatPassword = "repeatPassword";
  static passwordsDontMatch = "passwordsDontMatch";
  static somethingWentWrong = "somethingWentWrong";
  static padel = "padel";
  static chats = "chats";
  static noChatsYet = "noChatsYet";
  static findCompanyToPlay = "findCompanyToPlay";
  static findPlayers = "findPlayers";
  static noMessages = "noMessages";
  static typeYourMessage = "typeYourMessage";
  static unavailable = "unavailable";
  static myPadleLocation = "myPadleLocation";
  static searchMatchesInMilesFromMe = "searchMatchesInMilesFromMe";
  static previousPlaces = "previousPlaces";
  static moreCount = "moreCount";
  static available = "available";
  static geolocationNotSupported = "geolocationNotSupported";
  static geolocationDisabled = "geolocationDisabled";
  static tryAgain = "tryAgain";
  static allowGeolocation = "allowGeolocation";
  static nothingYet = "nothingYet";
  static fillOutYourProfile = "fillOutYourProfile";
  static helpsToMatchWithOpponents = "helpsToMatchWithOpponents";
  static addYourPhoto = "addYourPhoto";
  static finishCompletingYourProfile = "finishCompletingYourProfile";
  static yourStatusUnavailable = "yourStatusUnavailable";
  static clickToBecomeAvailable = "clickToBecomeAvailable";
  static yourStatusAvailable = "yourStatusAvailable";
  static clickToBecomeUnavailable = "clickToBecomeUnavailable";
  static peopleNearYouReadyToPlay = "peopleNearYouReadyToPlay";
  static matchesNearYouReadyToPlay = "matchesNearYouReadyToPlay";
  static inviteSeveralPeople = "inviteSeveralPeople";
  static matchesInApp = "matchesInApp";
  static visitSportClub = "visitSportClub";
  static play = "play";
  static experience = "experience";
  static createAMatch = "createAMatch";
  static chat = "chat";
  static noPlayersNearYou = "noPlayersNearYou";
  static noMatchesNearYou = "noMatchesNearYou";
  static readyToPlay = "readyToPlay";
  static year = "year";
  static years = "years";
  static map = "map";
  static reviews = "reviews";
  static today = "today";
  static dAgo = "dAgo";
  static bookingRequired = "bookingRequired";
  static artificialLight = "artificialLight";
  static lockerRooms = "lockerRooms";
  static parkingAvailability = "parkingAvailability";
  static filters = "filters";
  static rating = "rating";
  static placeOptions = "placeOptions";
  static notLessThan = "notLessThan";
  static clean = "clean";
  static apply = "apply";
  static all = "all";
  static addCourt = "addCourt";
  static addMarkLocationOnMap = "addMarkLocationOnMap";
  static confirm = "confirm";
  static howWouldYouDescribeThisLocation = "howWouldYouDescribeThisLocation";
  static howManyCourtsThisPlaceOffers = "howManyCourtsThisPlaceOffers";
  static galleryCourt = "galleryCourt";
  static firstImageWillBeMain = "firstImageWillBeMain";
  static rateCourts = "rateCourts";
  static description = "description";
  static courtOrClubName = "courtOrClubName";
  static addNameOfLocation = "addNameOfLocation";
  static addYourOpinionOfThisCourt = "addYourOpinionOfThisCourt";
  static addMoreDescription = "addMoreDescription";
  static addCourtToMap = "addCourtToMap";
  static areYouSureDontWantToAddTable = "areYouSureDontWantToAddTable";
  static moreNewPlacesToPlayMoreCommunity = "moreNewPlacesToPlayMoreCommunity";
  static courtAdded = "courtAdded";
  static afterQuickModerationPublished = "afterQuickModerationPublished";
  static thankYouForEngagement = "thankYouForEngagement";
  static cancel = "cancel";
  static address = "address";
  static enterAddress = "enterAddress";
  static places = "places";
  static addAPadelPlace = "addAPadelPlace";
  static mailAdded = "mailAdded";
  static mailExists = "mailExists";
  static profile = "profile";
  static logOut = "logOut";
  static edit = "edit";
  static questionnaire = "questionnaire";
  static padelSkillLevel = "padelSkillLevel";
  static participationInPadleSportsClub = "participationInPadleSportsClub";
  static howOftenDoYouPlayPadle = "howOftenDoYouPlayPadle";
  static dateOfBirthOnly = "dateOfBirthOnly";
  static showMyAgeInProfile = "showMyAgeInProfile";
  static genderOnly = "genderOnly";
  static preferToPlayMixedDoubles = "preferToPlayMixedDoubles";
  static showInMyProfile = "showInMyProfile";
  static infoAboutYourself = "infoAboutYourself";
  static addYourIndustry = "addYourIndustry";
  static peopleCommunicateWhenThereAreCommonTopics = "peopleCommunicateWhenThereAreCommonTopics";
  static done = "done";
  static yourCity = "yourCity";
  static wantToLeave = "wantToLeave";
  static weWillBeWaiting = "weWillBeWaiting";
  static notNow = "notNow";
  static home = "home";
  static notifications = "notifications";
  static youPlayWith = "youPlayWith";
  static change = "change";
  static selectLocationForGame = "selectLocationForGame";
  static yourInviteHasBeenSent = "yourInviteHasBeenSent";
  static pleaseWaitForApproval = "pleaseWaitForApproval";
  static deleteInvitation = "deleteInvitation";
  static goToChat = "goToChat";
  static areYouSureDeleteInvitation = "areYouSureDeleteInvitation";
  static finishGame = "finishGame";
  static areYouSureEndGame = "areYouSureEndGame";
  static acceptInvitation = "acceptInvitation";
  static courtNotSelected = "venueNotSelected";
  static selectACourt = "selectACourt";
  static selectUsers = "selectUsers";
  static usersNotSelected = "usersNotSelected";
  static afterOpponentsConfirm = "afterOpponentsConfirm";
  static notificationsEmpty = "notificationsEmpty";
  static yesterday = "yesterday";
  static sevenDaysBefore = "sevenDaysBefore";
  static last30Days = "last30Days";
  static notInvited = "notInvited";
  static pending = "pending";
  static declined = "declined";
  static decline = "decline";
  static accepted = "accepted";
  static accept = "accept";
  static matchConflictTitle = "matchConflictTitle";
  static matchConflictMessage = "matchConflictMessage";
  static completed = "completed";
  static invitations = "invitations";
  static leaveAReview = "leaveAReview";
  static describeYourExperience = "describeYourExperience";
  static send = "send";
  static yourReview = "yourReview";
  static shareYourExperience = "shareYourExperience";
  static streetAddress = "streetAddress";
  static coachAvailable = "coachAvailable";
  static socialVibe = "socialVibe";
  static cafeBar = "cafeBar";
  static rentalGear = "rentalGear";
  static playerBio = "playerBio";
  static infoAboutYourselfDescription = "infoAboutYourselfDescription";
  static findAPadelPlace = "findAPadelPlace";
  static whatTypeOfCourts = "whatTypeOfCourts";
  static locationWebsite = "locationWebsite";
  static enterTheLocationSite = "enterTheLocationSite";
  static approve = "approve";
  static reject = "reject";
  static noLocations = "noLocations";
  static noAccess = "noAccess";
  static selectTimeRange = "selectTimeRange";
  static morning = "morning";
  static midday = "midday";
  static evening = "evening";
  static selectSkillLevel = "selectSkillLevel";
  static selectDayAndMonth = "selectDayAndMonth";
  static spotsOpen = "spotsOpen";
  static owner = "owner";
  static noOtherPlayers = "noOtherPlayers";
  static matchDetails = "matchDetails";
  static matchInfo = "matchInfo";
  static notFound = "notFound";
  static addUser = "addUser";
  static removeUser = "removeUser";
  static startMatch = "startMatch";
  static cancelMatch = "cancelMatch";
  static endMatch = "endMatch";
  static matchEndSuccess = "matchEndSuccess";
  static matchEndFailure = "matchEndFailure";
  static matchCancelSuccess = "matchCancelSuccess";
  static matchCancelFailure = "matchCancelFailure";
  static leaveMatch = "leaveMatch";
  static joinMatch = "joinMatch";
  static removeUserFromMatch = "removeUserFromMatch";
  static waitingMatches = "waitingMatches";
  static inProgressMatches = "inProgressMatches";
  static canceledMatches = "canceledMatches";
  static completedMatches = "completedMatches";
  static noMatches = "noMatches";
  static matches = "matches";
  static matchDetail = "matchDetail";
  
  // Terms of Service
  static termsOfService = {
    padelMatchTermsOfService: "termsOfService.padelMatchTermsOfService",
    effectiveDate: "termsOfService.effectiveDate",
    agreementToTermsTitle: "termsOfService.agreementToTermsTitle",
    agreementToTermsContent: "termsOfService.agreementToTermsContent",
    eligibilityTitle: "termsOfService.eligibilityTitle",
    eligibilityContent: "termsOfService.eligibilityContent",
    theServiceTitle: "termsOfService.theServiceTitle",
    theServiceContent: "termsOfService.theServiceContent",
    userResponsibilitiesTitle: "termsOfService.userResponsibilitiesTitle",
    userResponsibilitiesContent: "termsOfService.userResponsibilitiesContent",
    userResponsibilitiesItem1: "termsOfService.userResponsibilitiesItem1",
    userResponsibilitiesItem2: "termsOfService.userResponsibilitiesItem2",
    userResponsibilitiesItem3: "termsOfService.userResponsibilitiesItem3",
    userResponsibilitiesItem4: "termsOfService.userResponsibilitiesItem4",
    paymentsBookingsTitle: "termsOfService.paymentsBookingsTitle",
    paymentsBookingsItem1: "termsOfService.paymentsBookingsItem1",
    paymentsBookingsItem2: "termsOfService.paymentsBookingsItem2",
    paymentsBookingsItem3: "termsOfService.paymentsBookingsItem3",
    intellectualPropertyTitle: "termsOfService.intellectualPropertyTitle",
    intellectualPropertyContent: "termsOfService.intellectualPropertyContent",
    terminationTitle: "termsOfService.terminationTitle",
    terminationContent: "termsOfService.terminationContent",
    disclaimersLiabilityTitle: "termsOfService.disclaimersLiabilityTitle",
    disclaimersLiabilityItem1: "termsOfService.disclaimersLiabilityItem1",
    disclaimersLiabilityItem2: "termsOfService.disclaimersLiabilityItem2",
    disclaimersLiabilityItem3: "termsOfService.disclaimersLiabilityItem3",
    governingLawTitle: "termsOfService.governingLawTitle",
    governingLawContent: "termsOfService.governingLawContent",
    changesToTermsTitle: "termsOfService.changesToTermsTitle",
    changesToTermsContent: "termsOfService.changesToTermsContent",
    contactUsTitle: "termsOfService.contactUsTitle",
    contactUsContent: "termsOfService.contactUsContent",
    contactUsEmail: "termsOfService.contactUsEmail",
  };
  
  // Privacy Policy
  static privacyPolicy = {
    padelMatchPrivacyPolicy: "privacyPolicy.padelMatchPrivacyPolicy",
    effectiveDate: "privacyPolicy.effectiveDate",
    introductionTitle: "privacyPolicy.introductionTitle",
    introductionContent1: "privacyPolicy.introductionContent1",
    introductionContent2: "privacyPolicy.introductionContent2",
    informationWeCollectTitle: "privacyPolicy.informationWeCollectTitle",
    informationYouProvideSubtitle: "privacyPolicy.informationYouProvideSubtitle",
    informationYouProvideItem1: "privacyPolicy.informationYouProvideItem1",
    informationYouProvideItem2: "privacyPolicy.informationYouProvideItem2",
    informationYouProvideItem3: "privacyPolicy.informationYouProvideItem3",
    informationWeCollectAutomaticallySubtitle: "privacyPolicy.informationWeCollectAutomaticallySubtitle",
    informationWeCollectAutomaticallyItem1: "privacyPolicy.informationWeCollectAutomaticallyItem1",
    informationWeCollectAutomaticallyItem2: "privacyPolicy.informationWeCollectAutomaticallyItem2",
    informationWeCollectAutomaticallyItem3: "privacyPolicy.informationWeCollectAutomaticallyItem3",
    informationFromThirdPartiesSubtitle: "privacyPolicy.informationFromThirdPartiesSubtitle",
    informationFromThirdPartiesItem1: "privacyPolicy.informationFromThirdPartiesItem1",
    howWeUseYourInformationTitle: "privacyPolicy.howWeUseYourInformationTitle",
    howWeUseYourInformationContent: "privacyPolicy.howWeUseYourInformationContent",
    howWeUseYourInformationItem1: "privacyPolicy.howWeUseYourInformationItem1",
    howWeUseYourInformationItem2: "privacyPolicy.howWeUseYourInformationItem2",
    howWeUseYourInformationItem3: "privacyPolicy.howWeUseYourInformationItem3",
    howWeUseYourInformationItem4: "privacyPolicy.howWeUseYourInformationItem4",
    howWeUseYourInformationItem5: "privacyPolicy.howWeUseYourInformationItem5",
    howWeShareYourInformationTitle: "privacyPolicy.howWeShareYourInformationTitle",
    howWeShareYourInformationContent: "privacyPolicy.howWeShareYourInformationContent",
    howWeShareYourInformationItem1: "privacyPolicy.howWeShareYourInformationItem1",
    howWeShareYourInformationItem2: "privacyPolicy.howWeShareYourInformationItem2",
    howWeShareYourInformationItem3: "privacyPolicy.howWeShareYourInformationItem3",
    yourChoicesTitle: "privacyPolicy.yourChoicesTitle",
    yourChoicesItem1: "privacyPolicy.yourChoicesItem1",
    yourChoicesItem2: "privacyPolicy.yourChoicesItem2",
    yourChoicesItem3: "privacyPolicy.yourChoicesItem3",
    dataSecurityTitle: "privacyPolicy.dataSecurityTitle",
    dataSecurityContent: "privacyPolicy.dataSecurityContent",
    internationalUsersTitle: "privacyPolicy.internationalUsersTitle",
    internationalUsersContent: "privacyPolicy.internationalUsersContent",
    changesToThisPolicyTitle: "privacyPolicy.changesToThisPolicyTitle",
    changesToThisPolicyContent: "privacyPolicy.changesToThisPolicyContent",
    contactUsTitle: "privacyPolicy.contactUsTitle",
    contactUsContent1: "privacyPolicy.contactUsContent1",
    contactUsContent2: "privacyPolicy.contactUsContent2",
    contactUsEmail: "privacyPolicy.contactUsEmail",
  };

  // Social Authentication Errors
  static googleLoginFailed = "googleLoginFailed";
  static authorizationCancelledByUser = "authorizationCancelledByUser";
  static appleAuthorizationError = "appleAuthorizationError";
  static appleAuthorizationConfigError = "appleAuthorizationConfigError";
  static appleLoginError = "appleLoginError";
  static facebookSdkLoading = "facebookSdkLoading";
  static appleIdNotLoaded = "appleIdNotLoaded";
}
